// extracted by mini-css-extract-plugin
export default {"panel":"CanvasElementPanel_panel__gy1F8","panel--drag":"CanvasElementPanel_panel--drag__gIUje"};